var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"negotiates"},[_c('div',{staticClass:"content_area"},[_c('negotiate',{attrs:{"isType":'tabs'}}),_c('allVideo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }